import { DEVICE_TYPES } from "./constants";

const versionValidation = (a, b) => {
  const segment = (vers) => vers.split(".").map((vers) => Number(vers));
  const segA = segment(a);
  const segB = segment(b);

  if (segA.length !== segB.length) {
    return false;
  }

  for (let i = 0; i < segA.length; i++) {
    if (segA[i] < segB[i]) {
      return true;
    } else if (segA[i] > segB[i]) {
      return false;
    } else {
      continue;
    }
  }

  return true;
};

export const isSupportedFirmware = ({
  type,
  fwVersion,
  minVersion,
  maxVersion,
}) => {
  let supported = false;

  if (!fwVersion) {
    return supported;
  } else {
    switch (type) {
      case DEVICE_TYPES.TWIG.NAME:
        const match = DEVICE_TYPES.TWIG.FW_REGEX.exec(fwVersion);
        if (!match?.groups) {
          supported = false;
          break;
        }

        const { range, major, minor } = match.groups;

        if (range && major && minor) {
          const versionStr = `${range}.${major}.${minor}`;

          if (minVersion && maxVersion) {
            supported =
              versionValidation(minVersion, versionStr) &&
              versionValidation(versionStr, maxVersion);
          } else if (minVersion) {
            supported = versionValidation(minVersion, versionStr);
          } else if (maxVersion) {
            supported = versionValidation(versionStr, maxVersion);
          }
        }

        break;
      default:
        supported = false;
        break;
    }
  }

  return supported;
};

export const twigRangeResolver = (fwVersion) => {
  if (!fwVersion) return false;

  const regex = /[C|T]T([0-9])[P|W]\.([0-9]{2})\.([0-9]{3})\.0000/;
  if (!regex.test(fwVersion)) {
    return false;
  } else {
    return true;
  }
};
